module.exports = __webpack_public_path__ + "img/zuijia_46.cca51361.png";